module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "for"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/foreword#for"
    }
  }, [_c('i', [_vm._v("Foreword")]), _vm._v(" by Christine Pohl")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/acknowledgements#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "int"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Founding Community")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001"
    }
  }, [_vm._v("Jesus and His Friends")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Cultivating Christian Friendship")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conversations through History")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("“God with Us”")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Friendship and Remaining")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Exile")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Friendship and Family")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-005"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ch005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Testimony")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ch005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Friendship and Struggle")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Celebration")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Friendship and Joy")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#ch007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Christian Friendship Today")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#ch007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mustard Seeds of Hope")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "app"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix#app",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "note"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "idx-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index001#idx001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Names and Subjects")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "idx-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index002#idx002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Scripture")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab8948c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0